<div class="download-card" matRipple>
  <p [translate]="cardName"></p>
  <p [translate]="cardDescription"></p>
  <gb-icon [icon]="icon" [library]="iconLibrary"></gb-icon>
</div>
